<template>
  <div class="booking-block">
    <div class="booking-loader" v-if="showLoader"></div>
    <div class="container booking-block__container">
      <BlockBookingHeader v-if="asyncDone"/>
      <!--<BlockStepLocation v-if="asyncDone" :address="address"/>-->
      <BlockStepOptions v-if="asyncDone" :optionsTitle="optionsTitle" :productsOptions="products" :productsPopup="productsPopup"/>
      <BlockStepSize v-if="asyncDone"/>
      <BlockStepFrequency v-if="asyncDone" :frequency="frequency" :policyText="policyText"/>
      <BlockStepDates v-if="asyncDone" :asyncDone="asyncDone" :blockedDays="blockedDays" :blockedDaysRange="blockedDaysRange" :policyText="policyText"/>
      <BlockStepTime v-if="asyncDone" :policyText="policyText"/>
      <BlockStepAddress v-if="asyncDone"/>
      <BlockBookingFooter ref="Footer" v-if="asyncDone" :asyncDone="asyncDone"/>
    </div>
  </div><!-- .booking-block -->
</template>

<script>
import BlockBookingHeader from '../components/blocks/BlockBookingHeader.vue';
import BlockBookingFooter from '../components/blocks/BlockBookingFooter.vue';
// import BlockStepLocation from '../components/blocks/BlockStepLocation.vue';
import BlockStepSize from '../components/blocks/BlockStepSize.vue';
import BlockStepOptions from '../components/blocks/BlockStepOptions.vue';
import BlockStepFrequency from '../components/blocks/BlockStepFrequency.vue';
import BlockStepDates from '../components/blocks/BlockStepDates.vue';
import BlockStepTime from '../components/blocks/BlockStepTime.vue';
import BlockStepAddress from '../components/blocks/BlockStepAddress.vue';
import {requestStepsBase} from '../requests/requestStepsBase.js';
import Global from '../../js/shared/global';
import {mapGetters} from 'vuex';
import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(VueObserveVisibility);


export default {
  async beforeCreate() {
    await window.addEventListener('pageshow', (event) => {
      const historyTraversal =
          event.persisted ||
          (typeof window.performance !== 'undefined' &&
              window.performance.navigation.type === 2);

      if (historyTraversal) {
        Global.setCookie('isBack', true);
      }
    });
    await requestStepsBase(this);
    Global.deleteCookie('jumpStep');
    this.steps = this.getSteps;
    this.products = this.$store.getters['getProducts'];
    this.productsPopup = this.$store.getters['getProductsPopup'];
    this.optionsTitle = this.$store.getters['getOptionsStepTitle'];
    this.frequency = this.$store.getters['getFrequency'];
    this.blockedDays = this.$store.getters['getBlockedDays'];
    this.blockedDaysRange = this.$store.getters['getBlockedDaysRange'];
    this.policyText = this.$store.getters['getPolicyText'];
    this.asyncDone = true;
    // get address cookie
    this.address = Global.readCookie('address');
    this.showLoader = false;
    this.currentStep = this.getCurrentStep;
    this.previousStep = this.getPreviousStep;
    this.allowedPostCodes = this.getAllowedPostCodes;
    // if is selected date in past empty the cookie
    const calendarDay = Global.readCookie('selectedOneTimeDate');
    if (calendarDay) {
      const calendarDaySplit = calendarDay.split('T');
      const date = new Date(calendarDaySplit[0]);
      const today = new Date();
      if (this.pastDate(date, today)) {
        Global.setCookie('selectedOneTimeDate', '');
      }
    }
  },
  data() {
    return {
      steps: [],
      showLoader: true,
      address: {},
      currentStep: '',
      previousStep: '',
      allowedPostCodes: [],
      products: [],
      asyncDone: false,
      optionsTitle: '',
      frequency: [],
      blockedDays: [],
      blockedDaysRange: [],
      policyText: '',
      productsPopup: {}
    };
  },
  computed: {
    ...mapGetters([
      'getSteps',
      'getCurrentStep',
      'getPreviousStep',
      'getAllowedPostCodes',
    ]),
  },
  components: {
    BlockBookingHeader,
    BlockBookingFooter,
    // BlockStepLocation,
    BlockStepSize,
    BlockStepOptions,
    BlockStepFrequency,
    BlockStepDates,
    BlockStepTime,
    BlockStepAddress,
  },
  methods: {
    pastDate(firstDate, secondDate) {
      return firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
// .booking-loader {
//   &::before {
//     content: '';
//     position: fixed;
//     width: 100%;
//     height: 100%;
//     top: 0;
//     left: 0;
//     z-index: 9;
//     background: #4d86f9;
//   }
// }

// .booking-step {
// 	padding-top: 233px;
// }

// .booking-title {
// 	font-size: 40px;
// 	font-family: $font-main;
// 	font-weight: 700;
// 	font-style: normal;
// 	letter-spacing: normal;
// 	line-height: 1.2;
// 	text-align: center;
// 	color: $white;
// }

// .booking-steps__wrap {
// 	display: flex;
// 	flex-wrap: wrap;
// 	align-items: flex-start;
// 	justify-content: space-between;
// 	margin-top: 73px;
// }

// .booking-label {
// 	display: block;
// 	font-size: 16px;
// 	font-family: $font-main;
// 	font-weight: 600;
// 	font-style: normal;
// 	letter-spacing: 3.2px;
// 	line-height: 1.2;
// 	text-transform: uppercase;
// 	color: $pattens-blue;
// 	margin-bottom: 21px;

// 	span {
// 		color: $tree-poppy;
// 	}

// 	@include mq($lg) {
// 		margin-bottom: 15px;
// 	}

// 	@include mq($md) {
// 		font-size: 14px;
// 		margin-bottom: 10px;
// 	}
// }

// .booking-label__link {
// 	color: $white;
// 	text-transform: uppercase;
// 	text-decoration: underline;
// 	transition: $dur $ease;

// 	@include hover {
// 		color: $tree-poppy;
// 		text-decoration: underline;
// 	}
// }

// .booking-input {
// 	width: 100%;
// 	height: 60px;
// 	border-radius: 30px;
// 	background-color: $white;

// 	@include mq($lg) {
// 		height: 50px;
// 	}

// 	@include mq($md) {
// 		height: 45px;
// 	}
// }

// .booking-side__image {
// 	background-color: transparent;
// }

// .booking-steps__wrap-upper {
// 	display: flex;
// 	flex-direction: column;
// 	align-items: flex-start;
// 	max-width: 720px;
// 	width: 100%;
// }

// .booking-steps__wrap-upper-btns-wrap {
// 	display: flex;
// 	flex-direction: column;
// 	align-items: center;
// 	justify-content: center;
// 	margin: 0 15px;

// 	&.is-active {

// 		.booking-steps__btn {
// 			border-color: $tree-poppy;
// 			background-color: $white;
// 			color: $tree-poppy;
// 		}

// 		.booking-steps__wrap-upper-btns-text {
// 			color: $white;
// 		}
// 	}
// }

// .booking-steps__wrap-upper-btns {
// 	display: flex;
// 	flex-wrap: wrap;
// 	align-items: flex-start;
// 	justify-content: flex-start;
// 	width: 100%;
// 	margin: 0 -15px;
// }

// .booking-steps__btn {
// 	display: flex;
// 	align-items: center;
// 	justify-content: center;
// 	min-width: 220px;
// 	height: 74px;
// 	border: 3px solid $royal-blue;
// 	border-radius: 10px;
// 	background-color: $royal-blue;
// 	font-size: 20px;
// 	font-family: $font-main;
// 	font-weight: 700;
// 	font-style: normal;
// 	letter-spacing: normal;
// 	line-height: 1.2;
// 	text-align: center;
// 	color: $white;
// 	transition: $dur $ease;

// 	@include hover {
// 		background-color: $white;
// 		color: $royal-blue;
// 	}
// }

// .booking-steps__btn--large {
// 	min-width: 345px;
// }

// .booking-steps__wrap-upper-btns-text {
// 	font-size: 16px;
// 	font-family: $font-main;
// 	font-weight: 600;
// 	font-style: normal;
// 	letter-spacing: normal;
// 	line-height: 1.2;
// 	text-align: center;
// 	color: $baby-blue;
// 	margin-top: 18px;
// }

// .booking-steps__info {
// 	position: relative;
// 	font-size: 16px;
// 	font-family: $font-main;
// 	font-weight: 600;
// 	font-style: normal;
// 	letter-spacing: 0.32px;
// 	line-height: 1.2;
// 	text-transform: uppercase;
// 	color: $white;
// 	padding-left: 32px;
// 	transition: $dur $ease;

// 	@include hover {
// 		color: $tree-poppy;

// 		.booking-steps__info-ico {
// 			color: $tree-poppy;
// 		}
// 	}
// }

// .booking-steps__info-ico {
// 	font-size: 18px;
// 	height: 18px;
// 	color: $white;
// 	position: absolute;
// 	top: 50%;
// 	left: 0;
// 	transform: translateY(-50%);
// 	transition: $dur $ease;
// }

// .booking-steps__selected-info {
// 	position: relative;
// 	font-size: 18px;
// 	font-family: $font-main;
// 	font-weight: 600;
// 	font-style: normal;
// 	letter-spacing: normal;
// 	line-height: 26px;
// 	color: $white;
// 	width: 100%;
// 	padding-bottom: 60px;
// 	margin-top: 40px;

// 	&::after {
// 		content: '';
// 		display: block;
// 		width: 96%;
// 		height: 2px;
// 		background-color: $baby-blue;
// 		position: absolute;
// 		bottom: 0;
// 		left: 0;
// 	}
// }

// .booking-steps__wrap-upper-mid {
// 	width: 100%;
// 	margin-top: 40px;
// }

// .booking-steps__wrap-middle-btns {
// 	display: flex;
// 	flex-wrap: wrap;
// 	align-items: flex-start;
// 	justify-content: flex-start;
// 	margin-top: 31px;
// }

// .booking-steps__wrap-middle-btns-wrap {
// 	display: flex;
// 	align-items: center;
// 	justify-content: center;
// 	width: 78px;
// 	height: 74px;
// 	border-radius: 10px;
// 	background-color: $royal-blue;
// 	border: 3px solid $royal-blue;
// 	transition: $dur $ease;
// 	font-size: 22px;
// 	font-family: $font-main;
// 	font-weight: 600;
// 	font-style: normal;
// 	letter-spacing: normal;
// 	line-height: 1.2;
// 	text-align: center;
// 	text-transform: uppercase;
// 	color: $white;

// 	&.is-active {
// 		border: 3px solid $tree-poppy;
// 		background-color: $white;
// 		color: $tree-poppy;
// 	}

// 	@include hover {
// 		border: 3px solid $tree-poppy;
// 		color: $tree-poppy;
// 	}
// }

// .booking-steps__textarea {
// 	width: 100%;
// 	min-height: 120px;
// 	max-height: 120px;
// 	border-radius: 30px;
// 	resize: none;
// 	overflow-y: auto;
// 	background-color: $white;

// 	&::placeholder {
// 		font-size: 18px;
// 		font-family: $font-main;
// 		font-weight: 500;
// 		font-style: normal;
// 		letter-spacing: 0.09px;
// 		line-height: 1.2;
// 		color: $baby-blue;
// 	}
// }

// //BOOKING RANGE SLIDER

// .range-slider-hidden {
//     display: none !important;
// }

// .range-slider-rail, .range-slider-fill {
//     height: 10px;
//     border-radius: 111px;
// }

// .range-slider-knob {
//     width: 32px;
//     height: 32px;
//     background: $tree-poppy;
// }
</style>
